import { Tooltip } from "@mui/material";
import React from "react";
import ReplayIcon from "@mui/icons-material/Replay";
import { useDispatch, useSelector } from "react-redux";
import {
  failLocalMessage,
  retryLocalMessage,
  successLocalMessage,
} from "../../utils/actionUtils";
import * as apiService from "../../service/ApiService";

const RetryButton = ({ localId, recipientId, message }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  return (
    <Tooltip title="Failed to send. Click to retry.">
      <ReplayIcon
        sx={{
          width: "16px",
          height: "16px",
          cursor: "pointer",
          color: "#fff",
          backgroundColor: "#f00a",
          borderRadius: "50%",
          px: "1.5px",
          py: "1.5px",
          transition: "background-color 0.2s ease-in-out",
          "&:hover": {
            backgroundColor: "#f00",
          },
        }}
        onClick={() => {
          retryLocalMessage(dispatch, localId, recipientId);
          apiService.messageBasic(
            dispatch,
            {
              ...auth.accountData,
              recruiterId: recipientId,
              message,
            },
            {
              handleSuccess: (data) => {
                console.log("success", data);
                setTimeout(() => {
                  successLocalMessage(
                    dispatch,
                    localId,
                    recipientId,
                    data.data.msg_id
                  );
                }, 300);
              },
              handleError: (data) => {
                console.log("fail", data);
                failLocalMessage(dispatch, localId, recipientId);
              },
            }
          );
        }}
      />
    </Tooltip>
  );
};

export default RetryButton;
